export default function () {
  var accountRow = $('#project_account').parents('.form-group');

  const billingTypesWithoutAccount =
    JSON.parse(document.getElementById('data-billing-types-without-account').innerText);

  $('#project_billingType').change(function() {
    var billingType = parseInt($(this).val());
    if (billingTypesWithoutAccount.indexOf(billingType) !== -1) {
      accountRow.hide();
      return;
    }

    accountRow.show();
  });

  var links = $('.project-link-rows');
  var addLink = function() {
    var prototype = $('#prototype').html();
    var index = links.find('.project-link-row').length;
    var newForm = prototype.replace(/__name__/g, index);

    links.append(newForm);
    links.data('index', index + 1);
  };

  $('.add-link').click(function(e) {
    e.preventDefault();
    addLink();
  });

  $(document).on('click', '.project-link-row .remove', function(e) {
    e.preventDefault();
    $(this).parents('.project-link-row').remove();
  });
};



// WEBPACK FOOTER //
// ./assets/js/create-project.js